// @ts-expect-error untyped module
import { useEmbedContext } from '../../../hooks/useEmbedContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { Flex } from 'foundations-components/components/Flex';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { StorefrontHeaderView } from 'marketplace-ui-common/storefront/components/StorefrontHeaderView';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { useOfferingType } from '../../../context/OfferingTypeContext';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute';
import { getIsInApp } from '../../../selectors/app';
import { getModulesStorefrontRoute, getThemeCollectionPreviewRoute, getThemesStorefrontRoute } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function UnifiedSearchWrapper({
  children,
  isEmbedded
}) {
  if (isEmbedded) {
    return /*#__PURE__*/_jsx(MainSection, {
      paddingBlock: "300",
      color: "light",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(StorefrontHeaderView, {
    backgroundImage: "none",
    color: "purple",
    divider: true,
    children: children
  });
}
export default function DesktopBrowseBar({
  hasActiveOfferingType,
  previewCollectionId
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  const isPrerender = getIsPrerenderUserAgent();
  const isInApp = useSelector(getIsInApp);
  const offeringType = useOfferingType();
  const activeOfferingType = hasActiveOfferingType ? offeringType : null;
  const {
    getCollectionSlugs,
    getDisplayedCollections
  } = usePublishedCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType
  });
  const collections = getDisplayedCollections();
  const collectionSlugs = getCollectionSlugs();
  const activeCollectionRoutes = useMemo(() => collectionSlugs.map(slug => getThemesStorefrontRoute(slug)).concat(['/']), [collectionSlugs]);
  const isActiveCollectionRoute = useIsActiveRoute({
    pathname: previewCollectionId ? getThemeCollectionPreviewRoute(previewCollectionId) : activeCollectionRoutes
  }, true);
  return /*#__PURE__*/_jsx(UnifiedSearchWrapper, {
    isEmbedded: isEmbedded,
    children: /*#__PURE__*/_jsx(MainSectionInner, {
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        paddingBlock: "400",
        children: !isEmbedded ? /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(UIRouterButton, {
            "data-test-id": "storefront-nav-themes-button",
            size: "md",
            to: getThemesStorefrontRoute('all'),
            use: "link-on-dark",
            style: {
              textDecoration: activeOfferingType === 'THEME' ? 'underline' : 'none'
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.themes"
            })
          }), /*#__PURE__*/_jsx(UIRouterButton, {
            "data-test-id": "storefront-nav-modules-button",
            to: getModulesStorefrontRoute(),
            use: "link-on-dark",
            style: {
              textDecoration: activeOfferingType === 'MODULE' ? 'underline' : 'none'
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.modules"
            })
          })]
        }) : /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(UIDropdown, {
            buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.discover"
            }),
            "data-test-id": "storefront-nav-discover-dropdown",
            defaultOpen: isPrerender,
            children: /*#__PURE__*/_jsxs(UIList, {
              children: [/*#__PURE__*/_jsx(UIRouterButton, {
                to: getThemesStorefrontRoute(),
                "data-test-id": "storefront-nav-collection-button::all",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.storefront.nav.allCollections"
                })
              }), collections.map(({
                id,
                publishedListing
              }) => {
                if (!publishedListing) {
                  return null;
                }
                const {
                  slug,
                  title
                } = publishedListing;
                return /*#__PURE__*/_jsx(UIRouterButton, {
                  to: getThemesStorefrontRoute(slug),
                  "data-test-id": `storefront-nav-collection-button::${slug}`,
                  children: /*#__PURE__*/_jsx(SanitizedText, {
                    body: title,
                    WrapperComponent: "span"
                  })
                }, id);
              })]
            })
          }), /*#__PURE__*/_jsx(UIRouterButton, {
            "data-test-id": "storefront-nav-themes-button",
            to: getThemesStorefrontRoute('all'),
            style: {
              textDecoration: !isActiveCollectionRoute ? 'underline' : 'none'
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.themes"
            })
          })]
        })
      })
    })
  });
}